export default __webpack_public_path__ + "static/media/Acolyte's Threads of Balance.5d44477c.jpg";